import TextareaAutogrow from "stimulus-textarea-autogrow/dist/stimulus-textarea-autogrow.umd.js"

export default class extends TextareaAutogrow {
  connect () {
    super.connect()

    // A textarea filled while hidden (folded section, closed <details>) measures
    // 0px: grow it again once it is displayed.
    if (typeof ResizeObserver !== "undefined") {
      this.visibilityObserver = new ResizeObserver(() => {
        if (this.pendingAutogrow && this.visible()) this.autogrow()
      })
      this.visibilityObserver.observe(this.element)
    }

    this.modalElement = this.element.closest(".modal")
    if (!this.modalElement) return

    this.onModalShown = this.autogrow.bind(this)
    this.modalElement.addEventListener("shown.bs.modal", this.onModalShown)
  }

  disconnect () {
    this.visibilityObserver?.disconnect()

    if (this.modalElement && this.onModalShown) {
      this.modalElement.removeEventListener("shown.bs.modal", this.onModalShown)
    }

    super.disconnect()
  }

  autogrow () {
    this.pendingAutogrow = !this.visible()
    if (this.pendingAutogrow) {
      this.element.style.height = ""
      return
    }

    super.autogrow()
  }

  visible () {
    return this.element.getClientRects().length > 0
  }
}
